import * as yup from "yup";

export const ScholarshipProviderFormValidation = yup.object().shape({
    description: yup.string().required("O nome é obrigatório"),
    code: yup.string(),
    status: yup.bool().default(true),
    internalCode: yup.string(),
});
